<template>
  <div id="goods_sort_box">
    <div class="dropdown_menu_box"  :class="{'price_sort_style':price_sort != 'normal','class_type_style':class_type != 0}">
      <van-sticky :offset-top="0">
        <van-dropdown-menu :overlay="noModal">
          <van-dropdown-item v-model="class_type" @change="initList" :options="class_type_list"/>
          <van-dropdown-item v-model="price_sort" @change="initList" :options="price_sort_list"/>
        </van-dropdown-menu>
      </van-sticky>
    </div>
    <div class="goods_list_box">

      <van-list
        :immediate-check="false"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :offset="50"
        @load="onLoad"
      >
        <div class="goods_list" v-for="(item,index) in goods_list" :key="index" @click="toDetail(item.id)">
          <img class="goods_left" :src="item.pic" alt="">
          <div class="goods_right">
            <div class="goods_text">
              <p class="goods_title">{{item.name}}</p>
              <p class="goods_des">{{item.synopsis}}</p>
            </div>
            <div class="goods_price" v-if="item.is_deduction && item.integral">
              <p v-if="item.preferential_price>0" ><span>￥</span>{{item.preferential_price}}<span class="Add"> + </span>{{item.integral}}<span>积分</span><s>￥{{item.original_price}}</s></p>
              <p v-else >{{item.integral}}<span>积分</span><s>{{item.original_price}}</s></p>
            </div>
            <div class="goods_price" v-else>
              <p ><span>￥</span>{{item.preferential_price}}<s>{{item.original_price}}</s></p>
            </div>

          </div>
        </div>
      </van-list>

    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      finished: false,
      loading: false,
      noModal: false,
      page: 1,
      class_type: 0,
      price_sort: 'normal',
      class_type_list: [],
      price_sort_list: [
        { text: '默认价格排序', value: 'normal' },
        { text: '价格从高到低', value: 'desc' },
        { text: '价格从低到高', value: 'asc' }
      ],
      goods_list: []
    }
  },
  methods: {
    /* 修改筛选值 */
    initList () {
      this.page = 1
      this.backTop()
      this.getList()
    },
    /* 回到顶部 */
    backTop () {
      window.scrollTo(0, 0)
    },
    /* 跳转详情页 */
    toDetail (id) {
      this.$router.push({
        path: '/goods',
        query: { id: id }
      })
    },
    initData () {
      /* 分类 */
      this.axios(this.$API.GOODS_GETPARENT_CATEGORY).then(({ data }) => {
        this.class_type_list = data.data.map((item) => {
          return {
            text: item.name,
            value: item.id,
            flag: item.flag
          }
        })
        this.class_type_list.unshift({
          text: '全部',
          value: 0
        })
      })
      this.getList()
    },
    /* 触发到底事件 */
    onLoad () {
      this.loading = true
      this.page++
      setTimeout(async () => {
        await this.getList()
        this.loading = false
      }, 1000)
    },
    /* 请求列表 */
    async getList () {
      const obj = { bcid: this.class_type, sorts: this.price_sort, page: this.page }
      await this.axios(this.$API.GOODS_GETGOODSLISTS, { params: obj }).then(({ data }) => {
        /* 判断是否需要是加载更多 */
        this.goods_list = this.page === 1 ? data.data.lists : this.goods_list.concat(data.data.lists)
        this.finished = this.goods_list.length >= data.data.count
        return Promise.resolve()
      })
    }
  },
  mounted () {
    if (this.$route.query.id) {
      this.class_type = Math.ceil(this.$route.query.id)
      console.log('this.class_type', typeof this.class_type)
    }
    this.initData()
  }
}
</script>

<style scoped lang="less">

  .goods_list_box{
    padding: 0 24px;
    .goods_list{
      margin-top: 24px;
      display: flex;
      .goods_text {
        height: 156px;
        .goods_title {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          font-size: 32px;
          color: #2b2b2b;
          font-family: PingFang TC, PingFang TC-Medium;
          font-weight: bold;
          line-height: 50px;
        }
        .goods_des {
          font-size: 24px;
          color: #9b9b9b;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          height: 50px;
          line-height: 50px;
        }
      }
      .goods_price{
        color: #e40505;
        font-size: 36px;
        span {
          font-size: 24px;
        }
        span.Add{
          font-size: 28px;
          font-weight: bold;
        }
        s {
          margin-left: 10px;
          font-size: 24px;
          color: #cecece;
        }
      }
      img{
        width: 200px;
        height: 200px;
        background-color: pink;
        margin-right: 16px;
      }
      .goods_right{
        flex: 1;
      }
    }
  }
  #goods_sort_box{
    background-color: #ffffff;
  }
  #goods_sort_box .class_type_style /deep/ .van-dropdown-menu__item:nth-child(1) {
    .van-ellipsis{
      color: #027cdf;
    }
    .van-dropdown-menu__title::after{
      border-color: transparent transparent #017cdf #017cdf
    }
  }
  #goods_sort_box .price_sort_style  /deep/ .van-dropdown-menu__item:nth-child(2) {
    .van-ellipsis{
      color: #027cdf;
    }
    .van-dropdown-menu__title::after{
      border-color: transparent transparent #017cdf #017cdf
    }
  }
  #goods_sort_box /deep/ .van-dropdown-menu__bar {
    background-color: #f5f5f6;
    .van-dropdown-menu__title {
      font-size: 28px;
    }
  }
  #goods_sort_box /deep/ .van-dropdown-menu__title::after{
    border-color: transparent transparent #999 #999;
  }
</style>
